// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-anchor_7122cbd3.default-anchor_7122cbd3 {
  font-weight: 600;
}
.dropdown-menu-title_7122cbd3.dropdown-menu-title_7122cbd3 {
  cursor: default;
}
.dropdown-menu-group_7122cbd3 .dropdown-menu-group-caption_7122cbd3 {
  cursor: default;
  color: #657682;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default-anchor": `default-anchor_7122cbd3`,
	"dropdown-menu-title": `dropdown-menu-title_7122cbd3`,
	"dropdown-menu-group": `dropdown-menu-group_7122cbd3`,
	"dropdown-menu-group-caption": `dropdown-menu-group-caption_7122cbd3`
};
export default ___CSS_LOADER_EXPORT___;
